import React, { Component } from 'react';
import {
    connect
} from 'react-redux';
import FormErrors from '../../../common/services/validateServices';
import "./styles.scss";
import { login, ACTIONS, getRoleUser } from './../../../actions/login';
import Loading from '../../../components/loading';
import { detectloginimgpcById, detectloginimgspById } from '../../../common/enum';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            formErrors: { email: '', password: '' },
            emailValid: false,
            passwordValid: false,
            formValid: false,
            value: '',
            statusLogin: false,
            saveInfoLogin: true,
            showLoading: false,
            randImg: ''
        }
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {
            case 'email':
                emailValid = value.match(/^([a-zA-Z_0-9]|[ｧ-ﾝﾞﾟ]|[0-9\@\.\_\-\+])*$/i);
                fieldValidationErrors.email = emailValid ? '' : 'が無効です';
                break;
            case 'password':
                passwordValid = value.length >= 6;
                fieldValidationErrors.password = passwordValid ? '' : 'が短すぎます';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            emailValid: emailValid,
            passwordValid: passwordValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.emailValid && this.state.passwordValid });
    }

    errorClass(error) {
        return (error.length === 0 ? '' : 'has-error');
    }

    UNSAFE_componentWillMount() {
        let account = unescape(localStorage.getItem('REMEMBER_ACCOUNT'));
        let arrAcc = account.split('#');
        let statusCheck = JSON.parse(localStorage.getItem('STATUS_CHECKBOX'));
        if (!statusCheck) {
            localStorage.removeItem('REMEMBER_ACCOUNT');
        } else {
            if (account) {
                this.setState({
                    formValid: true
                })
            }
            this.setState({
                saveInfoLogin: localStorage.getItem('STATUS_CHECKBOX') === 'true' ? true : false,
                email: arrAcc[0],
                password: arrAcc[1]
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.status === ACTIONS.LOGIN_SUCCESS && nextProps.response) {
            if (nextProps.response.access_token) {
                let account = escape(`${this.state.email}#${this.state.password}`);

                if (this.state.saveInfoLogin) {
                    localStorage.setItem('ACCESS_TOKEN', nextProps.response.access_token);
                    localStorage.setItem('REFRESH_TOKEN', nextProps.response.refresh_token);
                    localStorage.setItem('STATUS_CHECKBOX', this.state.saveInfoLogin);
                    localStorage.setItem('REMEMBER_ACCOUNT', account);
                } else {
                    document.cookie = `ACCESS_TOKEN=${nextProps.response.access_token}`;
                    document.cookie = `REFRESH_TOKEN=${nextProps.response.refresh_token}`;
                    localStorage.setItem('STATUS_CHECKBOX', false);
                }
                this.props.getRoleUser(nextProps.response.access_token)

            } else {
                this.setState({
                    showLoading: false,
                    statusLogin: true
                });
            }
        } else if (nextProps.status === ACTIONS.GET_ROLE_SUCCESS && nextProps.responseRole) {
            localStorage.setItem('USER_ID', nextProps.responseRole.id);
            localStorage.setItem('MEMBER', nextProps.responseRole.role);
            localStorage.setItem('MENUS', JSON.stringify(nextProps.responseRole.menus));
            let self = this;
            const offsetWidth = document.querySelector('.login').offsetWidth;
            setTimeout(function () {
                if ((offsetWidth < 768)){
                    self.props.history.push('/detailed-search');
                } else {
                    self.props.history.push('/dashboard');
                }
            }, 2000)
        }
    };

    handleLogin = (e) => {
        if (this.state.formValid) {
            this.setState({
                showLoading: true
            });
            e.preventDefault();

            let urlParamStr = window.location.search;
            urlParamStr = window.location.search.substring(1)
            let company = urlParamStr.split('&').reduce((acc, param) => {
                if (!/company/.test(param)) {
                    return acc;
                }
                const temp = param.split('=')
                return temp[1] ? temp[1] : '';
            }, '');

            const data = {
                email: (company ? company + '/' : '') + this.state.email,
                password: this.state.password
            };
            this.props.login(data);
        }

    }

    handleCheckbox = (e) => {
        this.setState({ saveInfoLogin: e });
    }

    render() {
        let randImg = Math.floor(Math.random() * 10);
        if ( this.state.randImg !== null && this.state.randImg !== '' ) {
            randImg = this.state.randImg;
        }
        this.state.randImg = randImg;
        return (
            <div style={{ width: '100%', height: '100vh', minHeight: 'inherit'}}>
                <div className="login">
                    <form className="loginForm custom-form" onSubmit={this.handleLogin} >
                        <h2 className="title-login">ログイン</h2>
                        {this.state.statusLogin ? <p className="text-message">ログインできませんでした</p> : ''}
                        <div className={`group ${this.errorClass(this.state.formErrors.email)}`}>
                            <input
                                ref="email"
                                type="tex"
                                required
                                className="input-text"
                                name="email"
                                placeholder="ログインID"
                                value={this.state.email}
                                onChange={this.handleUserInput}
                            />
                            <div className="notice">
                                <FormErrors formErrors={this.state.formErrors} nameForm="login" nameInput="email" />
                            </div>
                        </div>
                        <div className={`group ${this.errorClass(this.state.formErrors.password)}`}>
                            <input
                                ref="password"
                                type="password"
                                className="input-text"
                                name="password"
                                placeholder="パスワード"
                                value={this.state.password}
                                onChange={this.handleUserInput} />
                            <div className="notice">
                                <FormErrors formErrors={this.state.formErrors} nameForm="login" nameInput="password" />
                            </div>
                        </div>
                        <div style={{width: '100%', height: 50}} />
                        <button
                            type="submit"
                            className="button d-block mx-auto"
                            disabled={!this.state.formValid}>ログイン</button>
                    </form>
                    <div style={{
                        width: '55%',
                        justifyContent: 'center',
                        alignItems: 'center',

                    }}>
                        <img class="loginimg" src={detectloginimgpcById(randImg)} alt=""></img>
                    </div>
                    <Loading show={this.state.showLoading} />
                </div>

                <div className="login_sp">
                    <div style={{
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',

                    }}>
                        <img class="loginimg" src={detectloginimgspById(randImg)} alt=""></img>
                    </div>
                    <form className="loginForm-sp loginForm custom-form" onSubmit={this.handleLogin} >
                        <h2 className="title-login-sp">ログイン</h2>
                        {this.state.statusLogin ? <p className="text-message">ログインできませんでした</p> : ''}
                        <div className={`group ${this.errorClass(this.state.formErrors.email)}`}>
                            <input
                                ref="email"
                                type="tex"
                                required
                                className="input-text"
                                name="email"
                                placeholder="ログインID"
                                value={this.state.email}
                                onChange={this.handleUserInput}
                            />
                            <div className="notice">
                                <FormErrors formErrors={this.state.formErrors} nameForm="login" nameInput="email" />
                            </div>
                        </div>
                        <div className={`group ${this.errorClass(this.state.formErrors.password)}`}>
                            <input
                                ref="password"
                                type="password"
                                className="input-text"
                                name="password"
                                placeholder="パスワード"
                                value={this.state.password}
                                onChange={this.handleUserInput} />
                            <div className="notice">
                                <FormErrors formErrors={this.state.formErrors} nameForm="login" nameInput="password" />
                            </div>
                        </div>
                        <div style={{width: '100%', height: 46}} />
                        <button
                            type="submit"
                            className="button d-block mx-auto"
                            disabled={!this.state.formValid}>ログイン</button>
                    </form>
                    <Loading show={this.state.showLoading} />
                </div>

            </div>

        )
    }
}

const mapStateToProps = ({ login }) => {
    return {
        status: login.status,
        response: login.response,
        responseRole: login.responseRole
    }
}

const mapDispatchToProps = dispatch => {
    return {
        login: (data) => {
            dispatch(login(data));
        },
        getRoleUser: (token) => {
            dispatch(getRoleUser(token));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
